import Vue from 'vue';
import Router from 'vue-router'; 

Vue.use(Router);

export const constantRouterMap = [
//    {
//    path: '/',
//    component: function (resolve) {
//        require(['../com/admin/login.vue'], resolve);
//    },
//    hidden: true
//},
    {
        path: '/a_index',
        component: function (resolve) {
            require(['../views/a_index'], resolve);
        },
        meta: {
            title: '力波啤酒',
            showTab: true
        }
    }, 
    {
        path: '/a_result',
        component: function (resolve) {
            require(['../views/a_result'], resolve);
        },
        meta: {
            title: '开奖结果',
            showTab: true
        }
    }, 
    {
        path: '/a_mine',
        component: function (resolve) {
            require(['../views/a_mine'], resolve);
        },
        meta: {
            title: '个人中心',
            showTab: true
        }
    }, 
    {
        path: '/a_records',
        component: function (resolve) {
            require(['../views/a_records'], resolve);
        },
        meta: {
            title: '注册记录',
            showTab: true
        }
    }, 
    {
        path: '/a_my_prize',
        component: function (resolve) {
            require(['../views/a_my_prize'], resolve);
        },
        meta: {
            title: '我的奖品',
            showTab: true
        }
    }, 
    {
        path: '/a_register',
        component: function (resolve) {
            require(['../views/a_register/index'], resolve);
        },
        meta: {
            title: '店主注册',
            showTab: true
        }
    },   
    {
        path: '/b_register',
        component: function (resolve) {
            require(['../views/b_register/index'], resolve);
        },
        meta: {
            title: '稽查员注册', 
            showTab: true
        }
    }, 
    {
        path: '/b_index',
        component: function (resolve) {
            require(['../views/b_index/index'], resolve);
        },
        meta: {
            title: '稽查员注册', 
            showTab: true
        }
    },   
    {
        path: '/b_result1',
        component: function (resolve) {
            require(['../views/b_result1/index'], resolve);
        },
        meta: {
            title: '查询结果', 
            showTab: true
        }
    },  
    {
        path: '/b_result2',
        component: function (resolve) {
            require(['../views/b_result2/index'], resolve);
        },
        meta: {
            title: '查询结果', 
            showTab: true
        }
    },  
    {
        path: '/b_query_list',
        component: function (resolve) {
            require(['../views/b_query_list/index'], resolve);
        },
        meta: {
            title: '稽查记录', 
            showTab: true
        }
    },  
    {
        path: '/c_query',
        component: function (resolve) {
            require(['../views/c_query/index'], resolve);
        },
        meta: {
            title: '上海力波啤酒箱码查验', 
            showTab: true
        }
    }, 
    {
        path: '/c_result',
        component: function (resolve) {
            require(['../views/c_result/index'], resolve);
        },
        meta: {
            title: '上海力波啤酒箱码查验结果', 
            showTab: true
        }
    },  
    {
        path: '/d_query',
        component: function (resolve) {
            require(['../views/d_query/index'], resolve);
        },
        meta: {
            title: '上海力波啤酒内外箱码查验', 
            showTab: true
        }
    },  
    {
        path: '/d_result',
        component: function (resolve) {
            require(['../views/d_result/index'], resolve);
        },
        meta: {
            title: '上海力波啤酒箱码查验结果', 
            showTab: true
        }
    },  

];
export default new Router({
    linkActiveClass: 'active',
    routes: constantRouterMap,
    base: '/',
    mode: 'history'
});
//export const asyncRouterMap = [item];
export const asyncRouterMap = [];



// WEBPACK FOOTER //
// ./src/menu/index.js